var map = {
	"./1000171405.jpeg": [
		5122,
		5122
	],
	"./Autorenue Li3ib.pdf": [
		9233,
		9233
	],
	"./Capture.PNG": [
		3823,
		3823
	],
	"./Dashboard/GroupRegistrationReport_01-09-2025.xlsx": [
		2790,
		2790
	],
	"./Dashboard/GroupRegistrationReport_02-09-2025 (1).xlsx": [
		1053,
		1053
	],
	"./Dashboard/GroupRegistrationReport_02-09-2025.xlsx": [
		7967,
		7967
	],
	"./Dashboard/Money.svg": [
		4359,
		4359
	],
	"./Dashboard/graph.svg": [
		3615,
		3615
	],
	"./EventDefaultImage.svg": [
		2472,
		2472
	],
	"./Nationality.png": [
		4308,
		4308
	],
	"./No_Image_Available.jpg": [
		7363,
		7363
	],
	"./Suffix Agent. (1).pdf": [
		8730,
		8730
	],
	"./Suffixclent_logo.svg": [
		9323,
		9323
	],
	"./Welcome_Page.png": [
		8690,
		8690
	],
	"./Welcome_Screen.png": [
		9455
	],
	"./add-ons.svg": [
		8414,
		8414
	],
	"./bg_io.png": [
		6126,
		6126
	],
	"./birthday.png": [
		6891,
		6891
	],
	"./file_example_MP4_480_1_5MG.mp4": [
		3921,
		3921
	],
	"./flags/kw.svg": [
		5616,
		5616
	],
	"./fonts/graphik-arabic-medium.woff2": [
		1584
	],
	"./fonts/graphik-arabic-regular.woff2": [
		3843
	],
	"./fonts/graphik-medium.woff2": [
		8065
	],
	"./fonts/graphik-regular.woff2": [
		5456
	],
	"./icons/arrow-left-line.png": [
		5079
	],
	"./icons/arrow-right-line.png": [
		9588,
		9588
	],
	"./icons/choose_file.png": [
		7545,
		7545
	],
	"./icons/choose_file.svg": [
		4757,
		4757
	],
	"./icons/cms.svg": [
		8002,
		8002
	],
	"./icons/cms1.svg": [
		6207,
		6207
	],
	"./icons/customer.svg": [
		7511,
		7511
	],
	"./icons/dashboard .svg": [
		8751,
		8751
	],
	"./icons/down.png": [
		1505,
		1505
	],
	"./icons/event.svg": [
		7449,
		7449
	],
	"./icons/icon-field.svg": [
		7431,
		7431
	],
	"./icons/icon-google-marker.svg": [
		899,
		899
	],
	"./icons/icon-sider-trigger.svg": [
		6013,
		6013
	],
	"./icons/icon-triangle.svg": [
		7069,
		7069
	],
	"./icons/logout.svg": [
		4277,
		4277
	],
	"./icons/logs.svg": [
		326,
		326
	],
	"./icons/notification .svg": [
		602,
		602
	],
	"./icons/pdf_icon.png": [
		7079,
		7079
	],
	"./icons/pencil-line.png": [
		1971,
		1971
	],
	"./icons/settings-5-fill.png": [
		7288,
		7288
	],
	"./icons/shop_item.svg": [
		8959,
		8959
	],
	"./icons/transaction.svg": [
		7645,
		7645
	],
	"./icons/transfer.svg": [
		7422,
		7422
	],
	"./icons/user.svg": [
		698,
		698
	],
	"./icons/vending-machine.svg": [
		4022,
		4022
	],
	"./increase.svg": [
		5358,
		5358
	],
	"./logo2.png": [
		4343
	],
	"./main_login.png": [
		1033
	],
	"./newlogo.png": [
		5005,
		5005
	],
	"./newlogo.svg": [
		1057,
		1057
	],
	"./no_permission.jpg": [
		8815,
		8815
	],
	"./participate.svg": [
		1526,
		1526
	],
	"./patten_01.png": [
		9376
	],
	"./patten_02.png": [
		4411
	],
	"./patterned-background.svg": [
		792,
		792
	],
	"./permission.png": [
		4617
	],
	"./refund .svg": [
		4216,
		4216
	],
	"./report.csv": [
		6198,
		6198
	],
	"./revenue.svg": [
		8758,
		8758
	],
	"./spiner.svg": [
		5831,
		5831
	],
	"./suffix-admin-logo.svg": [
		2181,
		2181
	],
	"./suffix-logo.svg": [
		3451,
		3451
	],
	"./tickets.svg": [
		6429,
		6429
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8388;
module.exports = webpackAsyncContext;